"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyPolicy() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: narrativeRef,
    isVisible: narrativeVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="3311" id="privacypolicy" className="bg-background text-foreground py-24 md:py-40 lg:py-[200px] px-6 md:px-12 lg:px-20">
      <div className="max-w-[1400px] mx-auto">
        <div className="font-default text-xs md:text-sm uppercase tracking-widest text-foreground mb-16 md:mb-24" style={{
        letterSpacing: "0.15em"
      }}>
          02 &mdash; PRIVACY
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          <div ref={titleRef} className={`lg:col-span-4 transition-all duration-1000 ease-out ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="lg:sticky lg:top-32">
              <h1 className="font-default font-bold text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-foreground" style={{
              letterSpacing: "-0.03em"
            }}>
                Our Privacy
                <br />
                Commitment
              </h1>
              <div className="mt-6 flex items-center gap-3">
                <span className="block w-10 h-px bg-foreground" />
                <p className="font-default italic text-sm md:text-base text-muted-foreground">
                  Protecting your data, 2025
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <div ref={narrativeRef} className={`transition-all duration-1000 ease-out ${narrativeVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                <span className="float-left font-default font-bold text-[80px] md:text-[96px] leading-[0.85] mr-3 mt-1 text-primary" style={{
                letterSpacing: "-0.04em"
              }}>
                  W
                </span>
                e understand that leaving Illinois is a significant life decision, and we treat your personal information with the utmost discretion. When you engage with LeavingIL.com, you are trusting us with your relocation goals. We collect only the data necessary to provide you with a seamless exit strategy, ensuring your privacy remains protected throughout every step of your transition.
              </p>

              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                Our commitment to you is simple: we do not sell your personal data to third parties. Any information shared with our network of real estate professionals is done strictly with your explicit consent to facilitate your move. We utilize industry-standard security measures to safeguard your contact details and relocation preferences, ensuring that your journey out of the state remains confidential and secure.
              </p>

              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                Transparency is the foundation of our service. Whether you are just beginning to explore your options or are ready to list your property, you have full control over your data. You may request to view, update, or delete your information at any time. We are here to help you move forward with confidence, knowing your privacy is our priority.
              </p>

              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                Mobile information and SMS opt-in consent will not be shared with third parties or affiliates for marketing or promotional purposes. Text messaging originator opt-in data and consent will not be shared with any third parties, except as necessary to provide SMS messaging services.
              </p>
            </div>

            <div ref={quoteRef} className={`my-16 md:my-20 py-16 md:py-20 transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
              <div className="h-px w-full bg-primary" />
              <blockquote className="font-default italic text-2xl md:text-3xl lg:text-[32px] text-center text-foreground py-12 md:py-16 px-4" style={{
              lineHeight: "1.4",
              letterSpacing: "-0.01em"
            }}>
                &ldquo;Your relocation journey is private, and we keep it that way.&rdquo;
              </blockquote>
              <div className="h-px w-full bg-primary" />
            </div>

            <div className={`transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                We continuously monitor our digital infrastructure to prevent unauthorized access. By choosing to work with us, you are partnering with a team that values your trust above all else. We believe that a successful exit plan requires not just expert real estate guidance, but also the peace of mind that comes from knowing your personal details are handled with integrity.
              </p>
            </div>

            <div ref={imageRef} className={`mt-16 md:mt-20 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="relative w-full overflow-hidden rounded-lg shadow-lg" style={{
              aspectRatio: "21/9"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/secure_data_protection.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/secure_data_protection.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/secure_data_protection.webp-wvc-sizes" alt="Abstract representation of digital security and data protection" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>
              <p className="font-default italic text-[13px] text-foreground mt-4">
                Data security protocols, 2025.
              </p>
            </div>

            <div className={`mt-16 transition-all duration-1000 ease-out delay-200 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <h2 className="font-default font-bold text-2xl md:text-3xl text-foreground mb-6" style={{
              letterSpacing: "-0.02em"
            }}>
                SMS Communications
              </h2>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-6" style={{
              lineHeight: "1.75"
            }}>
                If you provide your mobile phone number and consent to receive SMS messages from LeavingIL.com, you may receive text messages regarding your inquiries, appointment reminders, real estate updates, and occasional marketing communications.
              </p>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-6" style={{
              lineHeight: "1.75"
            }}>
                By opting in, you agree to receive recurring automated text messages from Edward Dring and LeavingIL.com. Message frequency varies.
              </p>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-6" style={{
              lineHeight: "1.75"
            }}>
                Message and data rates may apply.
              </p>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-6" style={{
              lineHeight: "1.75"
            }}>
                Reply STOP at any time to opt out of future messages.
              </p>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-6" style={{
              lineHeight: "1.75"
            }}>
                Reply HELP for assistance.
              </p>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-6" style={{
              lineHeight: "1.75"
            }}>
                Consent to receive SMS messages is not a condition of purchasing any goods or services.
              </p>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-12" style={{
              lineHeight: "1.75"
            }}>
                Your SMS consent and phone number will not be shared with third parties or affiliates for marketing or promotional purposes.
              </p>

              <h2 className="font-default font-bold text-2xl md:text-3xl text-foreground mb-6" style={{
              letterSpacing: "-0.02em"
            }}>
                Cookies and Tracking Technologies
              </h2>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-6" style={{
              lineHeight: "1.75"
            }}>
                LeavingIL.com uses cookies and similar tracking technologies to improve your experience, analyze website traffic, and enhance website functionality.
              </p>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-4" style={{
              lineHeight: "1.75"
            }}>
                These technologies may include:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6 font-default text-[17px] md:text-[19px] text-foreground" style={{
              lineHeight: "1.75"
            }}>
                <li>Cookies</li>
                <li>Google Analytics</li>
                <li>Google Search Console</li>
                <li>Meta (Facebook) Pixel (if enabled)</li>
                <li>Microsoft Clarity (if enabled)</li>
              </ul>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-6" style={{
              lineHeight: "1.75"
            }}>
                These tools collect anonymous information about how visitors use our website. This information helps us improve our website and services.
              </p>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-12" style={{
              lineHeight: "1.75"
            }}>
                You can control or disable cookies through your browser settings. Disabling cookies may affect certain website features.
              </p>

              <div className="pt-8 border-t border-border">
                <p className="font-default text-[17px] md:text-[19px] text-foreground" style={{
                lineHeight: "1.75"
              }}>
                  If you have any questions regarding our privacy practices or how we manage your information, please reach out to our support team. We are dedicated to providing clear, honest answers so you can focus on what truly matters: your next chapter. Thank you for trusting LeavingIL.com with your relocation needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}